import {Component} from '@angular/core';
import {IonicPage, NavController, NavParams} from 'ionic-angular';
import {FingerBoardPage} from "../finger-board/finger-board";
import {SorobanBoardPage} from "../soroban-board/soroban-board";
import {FightPage} from "../fight/fight";
import {TrainingPage} from "../training/training";

import { InAppBrowser } from '@ionic-native/in-app-browser';
import {DemoPage} from "../demo/demo";
import {AccountProvider} from "../../providers/account/account";
import {VideoListPage} from "../video-list/video-list";


/**
 * Generated class for the HomePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
    selector: 'page-home',
    templateUrl: 'home.html',
    providers: [InAppBrowser, AccountProvider]
})
export class HomePage {
    fingerBoardPage = FingerBoardPage;
    sorobanBoardPage = SorobanBoardPage;
    fightPage = FightPage;
    trainingPage = TrainingPage;
    demoPage = DemoPage;
    videoListPage = VideoListPage;

    isShowParent = false;
    isShowLearnEnglish = false;
    isDemo = false;
    profile = {
        metas: {}
    };


    public isShowParentalGate = false;

    constructor(public navCtrl: NavController,
                public navParams: NavParams,
                private iab: InAppBrowser,
                private accountProvider: AccountProvider) {
        this.isDemo = window.localStorage.getItem("TOKEN_KEY") === 'demo';
        this.checkParent();
        this.loadProfile();
    }

    ionViewDidLoad() {
        console.log('ionViewDidLoad HomePage');
    }

    checkParent() {
        const PARENT_MODE = window.localStorage.getItem('PARENT_MODE');
        console.log(PARENT_MODE);
        if (!PARENT_MODE) {
            this.isShowParent = true;
        }
    }

    openVideo() {
        this.isShowParentalGate = false;
        this.iab.create('https://www.youtube.com/channel/UC6uoWHUqbNkdRTIMs6o4vAA');
    }

    loadProfile() {
        if (!window.localStorage.getItem("TOKEN_KEY") || window.localStorage.getItem("TOKEN_KEY") === 'demo') {
            return;
        }

        this.accountProvider.loadProfile().subscribe(
            (resp: any) => {
                if (!resp.status) {
                    return;
                }

                this.profile = resp.data;
            },
            err => {
                console.log(err);
            }
        );
    }

}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts